import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchShortCoursePageTemplates } from "../../../../redux/actions/courseBuilderActions";
import CreatePageModal from "../../../../components/CourseBuilder/CreatePageModal";
import { useTheme } from "@mui/material/styles";
import { insertCustomerStyles } from "../../../../utils/htmlEditorUtils";

const CreateShortCoursePage = ({
  open,
  onClose,
  shortCourseTitle,
  onSubmitNewPage,
  shortCourseId,
  coursePage
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const shortCoursePageTemplates = useSelector(
    ({ courseBuilderState }) => courseBuilderState.shortCoursePageTemplates
  );

  useEffect(() => {
    if (!shortCoursePageTemplates) {
      dispatch(fetchShortCoursePageTemplates());
    }
  }, [shortCoursePageTemplates]);

  const templatesWithStyles = useMemo(() => {
    if (shortCoursePageTemplates) {
      return shortCoursePageTemplates.map(template => ({
        ...template,
        content: insertCustomerStyles(template.content, theme)
      }));
    } else {
      return [];
    }
  }, [shortCoursePageTemplates]);

  return (
    <CreatePageModal
      shortCoursePageTemplates={templatesWithStyles}
      open={open}
      onClose={onClose}
      shortCourseTitle={shortCourseTitle}
      onSubmit={onSubmitNewPage}
      shortCourseId={shortCourseId}
      coursePage={coursePage}
    />
  );
};

export default CreateShortCoursePage;
